import './App.css';

import React, {useState} from "react";
import HeaderGBar from "./HeaderBar/HeaderG";
import {Box, Grommet, Text, ResponsiveContext, Layer, Button, Heading, Paragraph} from "grommet";
import styled from "styled-components";
import TableauOutlookHolder from "./TableauOutlookHolder/TableauOutlookHolder";
import DataHolder from "./DataHolder/DataHolder";
import AboutHolder from "./AboutHolder/AboutHolder";
import TableauCDEHolder from "./TableauCDEHolder/TableauCDEHolder";
import {FormClose} from "grommet-icons";
import TableauETHolder from "./TableauETHolder/TableauETHolder";
import TableauOppHolder from "./TableauOppHolder/TableauOppHolder";


export const myTheme = {
    global: {
        colors: {
            brand: "#303030",
            "accent-1":"#222222",
            "focus":"#AAAAAA",
            controls: {
                light: "#b8b8b8"
            }
        },
        // font: {
        //     family: "Raleway"
        // }
    },
    anchor: {
        color: {
            dark: "#e9e9e9",
            light: "#4c4c4c"
        }
    },
    tab: {
        color: 'text',
        active: {
            background: 'neutral-3',
        },
        hover: {
            background: 'background-back',
            color: 'control',
        },
        border: {
            side: 'bottom',
            color: 'background-back',
            active: {
                color: 'border',
            },
            hover: {
                color: 'control',
            },
        },
        pad: 'small',
        margin: 'medium',
    },
    layer: {
        border: {
            radius: '18px',
            intelligentRounding: true,
        },
        container: {
            elevation: "medium"
        },
        zIndex: "5000"
    },
};

const VizDivWrapper = styled("div")`
`;

const Generic = (name) => {
    return <Box
        align="center"
        alignContent="center"
        justify="center"
        background="light-2"
        direction="column"
        fill="vertical"
    >
        <Box
            direction="row"
            align="center"
            alignContent="center"
            justify="center"
        >
            <Text
                textAlign="center"
                alignSelf="center"
            >
                {name}
            </Text>
        </Box>
    </Box>
        ;
};
// const Outlook = Generic("OUTLOOK");
const Outlook = <TableauOutlookHolder/>;
// const ChinaDebtExposure = Generic("China Debt Exposure");
const ChinaDebtExposure = <TableauCDEHolder/>;
// const EnvironmentalStress = Generic("Environmental Stress");
const EnvironmentalStress = <TableauETHolder/>;
// const Opportunities = Generic("Opportunities");
const Opportunities = <TableauOppHolder/>;


function App() {
    const [module, setModule] = useState("outlook");
    const [showIntro, setShowIntro] = useState(true);

    let viz = null;
    if (module === "outlook")
        viz = Outlook;
    else if (module === "data")
        viz = <DataHolder/>;
    else if (module === "about")
        viz = <AboutHolder changeModule={setModule}/>;
    else if (module === "cde")
        viz = ChinaDebtExposure;
    else if (module === "es")
        viz = EnvironmentalStress;
    else if (module === "opp")
        viz = Opportunities;

    return (
        <Grommet theme={myTheme} full={true}>
            {showIntro && (
                <Layer
                    onEsc={() => setShowIntro(false)}
                    onClickOutside={() => setShowIntro(false)}
                    animation="fadeIn"
                    background="light-1"
                    // full={true}
                >
                    <Box
                        width='55vw'
                        height='65vh'
                    >
                        <Button size="large" alignSelf="end" icon={<FormClose size="40px"/>} onClick={() => setShowIntro(false)} />
                        <Box
                            pad={{left:"medium", right:"medium", bottom:"medium"    }}
                        >
                            <Box
                                overflow="scroll"
                            >
                                <Heading fill margin="none" color="#CE0F12" level={3}>
                                    China, Debt, Climate and Nature: Opportunities for
                                    Financial Stability
                                </Heading>
                                <Paragraph fill size="small">
                                    This interactive explores opportunities for China to alleviate debt burdens in exchange for debtor nation commitments to climate change mitigation and/or adaptation and environmental protection through “debt-for-climate” and “debt-for-nature” swaps.
                                </Paragraph>
                                <Paragraph  fill size="small">
                                    As the world's largest bilateral creditor, China is in a unique position to help address both the global debt and environmental crises at once. Indeed, by adopting sustainable debt relief alternatives, like debt-for-nature and debt-for-climate swaps, China could continue to pursue mutual policy goals with its low- and middle-income debtor countries, while also cementing its status as a global leader on climate.
                                </Paragraph>
                                <Heading fill margin="none" color="#CE0F12" level={4}>
                                    How to explore this data
                                </Heading>
                                <Paragraph  fill size="small">
                                    In the <b>Global Outlook</b> page, you can view the characteristics of the 41 countries we have assessed according to their potential for debt-for-climate and/or debt-for-nature swaps.
                                </Paragraph>
                                <Paragraph  fill size="small">
                                    In the <b>Explore</b> tab, you can create maps and scatterplots with the data from our analysis (including financial, environmental, and opportunity data) to see how these characteristics vary between countries, and how the relationships between different variables may be useful for prioritizing countries for green debt relief strategies, like debt swaps.
                                </Paragraph>
                                <Paragraph  fill size="small">
                                    In the <b>Data</b> page, you can find a description of all the variables included in this interactive, as well as the original sources where you can obtain the data for your own projects or investigations.
                                </Paragraph>
                                <Paragraph  fill size="small">
                                    In the <b>About</b> page, you can learn more about this project and read a more detailed guide on how to utilize all the features on this site.
                                </Paragraph>
                            </Box>
                        </Box>
                        <Box
                            flex="grow"
                            pad={{right:"medium", bottom:"medium"}}
                        >
                            <Button size="medium" fill="vertical" alignSelf="end" label="Close" onClick={() => setShowIntro(false)}/>
                        </Box>
                    </Box>
                </Layer>
            )}
            <ResponsiveContext.Consumer>
                {size => (
                    <Box fill>
                        {/*<HeaderBar/>*/}
                        <HeaderGBar module={module} changeModule={setModule}/>
                        <Box
                            // fill="vertical"
                            flex
                            direction="column"
                        >
                            {viz}
                        </Box>
                    </Box>
                )}
            </ResponsiveContext.Consumer>
        </Grommet>
    );
}

export default App;
